import React, { useState, useEffect, useRef } from "react";
import "./style.scss";
import useTranslation from "../../../hooks/useTranslation";
import useStore from "../../../store";
import get from "lodash/get";

export default function HamburgerMenu() {
  const [isOpen, setIsOpen] = useState(false);
  const { tr } = useTranslation();
  const { company } = useStore((state) => state);
  const overlayRef = useRef(null);

  const toggleMenu = () => {
    setIsOpen(!isOpen);
  };

  // Prevent body scroll when menu is open
  useEffect(() => {
    if (isOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [isOpen]);

  // Close menu on Escape key
  useEffect(() => {
    const handleEscape = (e) => {
      if (e.key === "Escape" && isOpen) {
        setIsOpen(false);
      }
    };
    document.addEventListener("keydown", handleEscape);
    return () => document.removeEventListener("keydown", handleEscape);
  }, [isOpen]);

  console.log(company)

  function checkNumber(value) {
    const regex = /^998\d{9}$/;
    return regex.test(value);
  }

  function formatPhone(number) {
    if (!/^998\d{9}$/.test(number)) return null;

    return `+${number.slice(0,3)} ${number.slice(3,5)} ${number.slice(5,8)} ${number.slice(8,10)} ${number.slice(10,12)}`;
  }

  return (
    <div className="menu-box">
      <button
        onClick={toggleMenu}
        className={`navbar-header__top-button ${isOpen ? 'navbar-header__top-button--open' : ''}`}
        aria-label={isOpen ? tr("Закрыть меню") : tr("Открыть меню")}
      >
        <span className="navbar-header__hamburger-line navbar-header__hamburger-line--1"></span>
        <span className="navbar-header__hamburger-line navbar-header__hamburger-line--2"></span>
        <span className="navbar-header__hamburger-line navbar-header__hamburger-line--3"></span>
      </button>

      {/* Full-Screen Overlay Menu */}
      <div
        ref={overlayRef}
        className={`hamburger-menu__overlay ${isOpen ? 'hamburger-menu__overlay--open' : ''}`}
        onClick={(e) => {
          if (e.target === overlayRef.current) {
            setIsOpen(false);
          }
        }}
      >
        <div className="hamburger-menu__content">
          {/* Header */}
          <div className="hamburger-menu__header">
        <button
          onClick={toggleMenu}
              className="hamburger-menu__close-btn"
              aria-label={tr("Закрыть")}
        >
              <i className="fas fa-times"></i>
        </button>
            <div className="hamburger-menu__header-right">
              {(company?.instagram || company?.telegram || company?.facebook) && (
                <div className="hamburger-menu__social-links">
                  {company?.instagram && (
                    <a
                      href={company.instagram}
              target="_blank"
              rel="noopener noreferrer"
                      className="hamburger-menu__social-link"
                      aria-label="Instagram"
                    >
                      <i className="fab fa-instagram"></i>
                    </a>
                  )}
                  {company?.telegram && (
                    <a
                      href={company.telegram}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hamburger-menu__social-link"
                      aria-label="Telegram"
                    >
                      <i className="fab fa-telegram"></i>
                    </a>
                  )}
                  {company?.facebook && (
                    <a
                      href={company.facebook}
                      target="_blank"
                      rel="noopener noreferrer"
                      className="hamburger-menu__social-link"
                      aria-label="Facebook"
                    >
                      <i className="fab fa-facebook"></i>
                    </a>
                  )}
                </div>
              )}
            </div>
          </div>

          <div className="hamburger-menu__platform-section">
            <div className="hamburger-menu__platform-info">
              <h3 className="hamburger-menu__section-title">
                {tr("Связаться с нами")}
              </h3>

              <div className="hamburger-menu__contact-item">
                <div className="hamburger-menu__contact-icon">
                  <i className="fas fa-phone"></i>
                </div>
                <div className="hamburger-menu__contact-details">
                  <span className="hamburger-menu__contact-label">{tr("Телефон")}</span>
                  <div className="hamburger-menu__contact-phones">
                    <a href={`tel:+${get(company, 'phone')}`} className="hamburger-menu__contact-link">
                      {checkNumber(get(company, 'phone')) ? formatPhone(get(company, 'phone')) : get(company, 'phone')}
                    </a>
                    <a href={`tel:+${get(company, 'employee_phone')}`} className="hamburger-menu__contact-link">
                      {checkNumber(get(company, 'employee_phone')) ? formatPhone(get(company, 'employee_phone')) : get(company, 'employee_phone')}
                    </a>
                  </div>
                </div>
              </div>

              <div className="hamburger-menu__contact-item">
                <div className="hamburger-menu__contact-icon">
                  <i className="fas fa-map-marker-alt"></i>
                </div>
                <div className="hamburger-menu__contact-details">
                  <span className="hamburger-menu__contact-label">{tr("Адрес")}</span>
                  <span className="hamburger-menu__contact-link">
                   {get(company, 'setting.address', "")}
                  </span>
                </div>
              </div>

            </div>
          </div>

          {/* Current Company Section (Compact) */}
          <a href={"https://kafe.zim-zim.uz/signup"} target={"_blank"} className="hamburger-menu__company-section">
            <div className="hamburger-menu__company-divider">
              <span>Zim Zim</span>
            </div>
            <div className="hamburger-menu__company-card">
              <div className="hamburger-menu__company-logo">
                <img src="./logo.png" alt="ZIM-ZIM" />
              </div>
              <div className="hamburger-menu__company-info">
                <h4 className="hamburger-menu__company-name">
                  {tr("Restoranlar uchun onlayn menyu")}
                </h4>
              </div>
            </div>
          </a>

          {/* CTA Button */}
          <a href={"https://kafe.zim-zim.uz/signup"} target={"_blank"} className="hamburger-menu__cta-section">
            <button className="hamburger-menu__cta-button">
              <span className="hamburger-menu__cta-icon">
                <i className="fas fa-rocket"></i>
              </span>
              <div className="hamburger-menu__cta-text">
                <span className="hamburger-menu__cta-main">{tr("Станьте нашим клиентом")}</span>
                <span className="hamburger-menu__cta-sub">{tr("Быстрое подключение")}</span>
              </div>
            </button>
          </a>
        </div>
      </div>
    </div>
  );
}
